import { useEffect, useRef, useState } from 'react'

/** Copies a value to the clipboard and confirms it in place. */
export default function CopyButton({ value, label }: { value: string; label: string }) {
  const [copied, setCopied] = useState(false)
  const timer = useRef<ReturnType<typeof setTimeout>>(undefined)

  useEffect(() => () => clearTimeout(timer.current), [])

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(value)
      setCopied(true)
      timer.current = setTimeout(() => setCopied(false), 1600)
    } catch {
      // Clipboard is unavailable (insecure context) — nothing useful to do.
    }
  }

  return (
    <button type="button" className="sss-vz-btn" onClick={copy}>
      {copied ? 'Copied' : label}
    </button>
  )
}
